import { TextEncoderUtil } from '../../util/polyfill/text-encoder';

export class CryptoUtilService{
  static async getObjectHash(data: any): Promise<string>{
    const encoder = new TextEncoderUtil();
    const stringifiedData = JSON.stringify(data);
    const encodedData = encoder.encode(stringifiedData);

    const uint8ArrayData = new Uint8Array(encodedData);
    const hashBuffer = await crypto.subtle.digest({name:'SHA-256'}, uint8ArrayData);
    const hashArray = Array.from(new Uint8Array(hashBuffer));                     // convert buffer to byte array
    // convert bytes to hex string
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  }
}
